import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, EMPTY, of, BehaviorSubject } from 'rxjs';
import { ApiUsuarioService } from './api-usuario.service';
import { environment } from 'src/environments/environment';
import { switchMap, take, filter, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ControllerModalsService } from './controller-modals.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptorService implements HttpInterceptor {
  private ENV = environment;
  isRefreshToken: boolean = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private apiUsuario: ApiUsuarioService,
    private modalCtrl: ControllerModalsService,
    private router: Router,
    private utilsService: UtilsService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.get('check')) {
      let credenciais = this.apiUsuario.getCredenciais();
      let newHeaders: any = req.headers;
      newHeaders.headers.delete('check');
      let token;
      if (credenciais.data) credenciais = credenciais.data;
      let currentTime = new Date().getTime();
      let tempoAteExpirar = credenciais.expires - currentTime;
      if (
        tempoAteExpirar < this.ENV.apice.tempoReautenticacao &&
        !this.isRefreshToken && !credenciais.usuarioQueLogou
            ) {
        return this.refreshToken(req, next);
      } else if (
        this.isRefreshToken &&
        tempoAteExpirar < this.ENV.apice.tempoReautenticacao && !credenciais.usuarioQueLogou
      ) {
        // console.log('request await');
        return this.refreshTokenSubject.pipe(
          filter((token) => token != null),
          take(1),
          switchMap((jwt) => {
            let newHeaders: any = req.headers;
            newHeaders.headers.delete('check');
            newHeaders = newHeaders.append('Authorization', jwt);
            const authReq = req.clone({ headers: newHeaders });
            return next.handle(authReq);
          })
        );
      } else {
        // if (!this.refreshTokenSubject.value) this.refreshTokenSubject.next(credenciais.token);
        token = credenciais.token;
        newHeaders = newHeaders.append('Authorization', token);
        const authReq = req.clone({ headers: newHeaders });
        return next.handle(authReq);
      }
    } else {
      return next.handle(req);
    }
  }

  refreshFuncionou = false;
  public refreshToken(request?: HttpRequest<any>, next?: HttpHandler): any {
    this.isRefreshToken = true;
    this.refreshTokenSubject.next(null);
    let token = this.apiUsuario.getCredenciais().token;
    let newHeaders: any = request?.headers ? request.headers.append('Authorization', token) : new HttpHeaders({ 'Authorization': token });

    return this.apiUsuario.refreshToken(newHeaders).pipe(
      switchMap((authResponse: any) => {
        if (authResponse?.message) {
          this.handleUnauthorized(authResponse.message);
          return EMPTY;
        } else {
          try {
            return this.handleSuccessfulRefresh(authResponse, request, next);
          } catch (error) {
            console.error('Erro no handleSuccessfulRefresh:', error);
            return EMPTY;
          }
        }
      }),
      catchError(err => {
        return this.handleError(err, next);
      })
    );
  }

  private handleUnauthorized(message: string) {
    setTimeout(() => {
      console.log('Deslogar usuário');
      this.modalCtrl.closeAllModals();
      this.router.navigateByUrl('/login');
    }, 1500);
    this.mostraMensagem(message);
    this.refreshTokenSubject.next(null);
    this.isRefreshToken = false;
  }
  
  // Método para lidar com a renovação de token bem-sucedida
  private handleSuccessfulRefresh(auth: any, request?: HttpRequest<any>, next?: HttpHandler) {
    let sessao = this.apiUsuario.getCredenciais();
    if (sessao) {
      for (let prop in auth) {
        sessao[prop] = auth[prop];
      }
    }
    this.apiUsuario.armazenaLogin(sessao);
    this.refreshFuncionou = true;
    this.apiUsuario.atualizouPermissoes.set(true);
    this.refreshTokenSubject.next(sessao.token);
    this.isRefreshToken = false;
    if (request && next) {
      let newHeaders = request.headers
        .delete('check')
        .append('Authorization', sessao.token);
      const authReq = request.clone({ headers: newHeaders });
      return next.handle(authReq);
    } else {
      return EMPTY;
    }
  }
  
  private handleError(err: any, next: HttpHandler): Observable<any> {
    console.error('Erro ao renovar token:', err);
    let erro = "Falha ao processar requisição";
    if (typeof err?.error?.message === 'string') {
      erro = err.error.message;
    } else if (err?.url?.includes('refreshToken')) {
      erro = "Sua sessão expirou";
    }
    if (!this.refreshFuncionou) {
      this.handleUnauthorized(erro);
    } else {
      this.refreshFuncionou = false;
      this.refreshTokenSubject.next(null);
      this.isRefreshToken = false;
    }

    return throwError(() => new Error(erro));
  }

  private handleError2<T>(next?: any) {
    
    return (error: any): Observable<T> => {
      setTimeout(() => {
        this.modalCtrl.closeAllModals();
      }, 1000);
      this.refreshTokenSubject.next(null);
      this.isRefreshToken = false;
      this.router.navigateByUrl('/login');
      return next.handle(EMPTY);
    };
  }

  mostraMensagem(mensagem: string) {
    this.utilsService.alertCustom({ txt: mensagem,
      duration: 6000,
    });
  }
}
